export type ToastSeverity = 'success' | 'info' | 'warning' | 'error';
export interface ToastInput { severity: ToastSeverity; message: string; duration?: number; }
export interface Toast extends ToastInput { id: string; createdAt: number; duration: number; }

const DEFAULT_DURATION: Record<ToastSeverity, number> = { success: 3500, info: 4500, warning: 6000, error: 9000 };
const MAX_TOASTS = 3;

export function sanitizeFeedback(message: string): string {
  const safe = message.replace(/(?:api[_-]?key|authorization|token|secret)\s*[:=]\s*\S+/gi, 'citlivý údaj odstraněn').trim();
  return safe || 'Akci se nepodařilo dokončit.';
}

export class ToastStore {
  private items: Toast[] = [];
  private listeners = new Set<() => void>();
  getSnapshot = (): Toast[] => this.items;
  subscribe = (listener: () => void) => { this.listeners.add(listener); return () => this.listeners.delete(listener); };
  add(input: ToastInput): string {
    const message = sanitizeFeedback(input.message);
    const duplicate = this.items.find(item => item.message === message && item.severity === input.severity);
    if (duplicate) return duplicate.id;
    const toast: Toast = { ...input, message, id: crypto.randomUUID(), createdAt: Date.now(), duration: input.duration ?? DEFAULT_DURATION[input.severity] };
    this.items = [...this.items, toast].slice(-MAX_TOASTS);
    this.emit();
    return toast.id;
  }
  dismiss(id: string): void { this.items = this.items.filter(item => item.id !== id); this.emit(); }
  clear(): void { this.items = []; this.emit(); }
  private emit(): void { this.listeners.forEach(listener => listener()); }
}
